import styles from './AddToCalendar.module.scss';
import { FaGoogle, FaApple, FaWindows, FaYahoo } from 'react-icons/fa';

import ReactAddToCalendar from 'legacy/common/lib/react-add-to-calendar';
import classnames from 'classnames';
import { ReactNode } from 'react';
import { toCalendarEvent } from '../helpers';

type Props = {
  label?: ReactNode;
  event: ReturnType<typeof toCalendarEvent>;
  position?: 'left' | 'right';
};

const AddToCalendar = ({
  event,
  label = 'Add to Calendar',
  position = 'left'
}: Props) => (
  <ReactAddToCalendar
    event={event}
    buttonWrapperClass="text-sm text-primary-500"
    buttonTemplate={{ textOnly: 'none' }}
    buttonLabel={label}
    dropdownClass={classnames(
      'absolute top-6 text-sm bg-white border-1 rounded-xl overflow-hidden',
      position === 'left' ? 'left-3' : 'right-0',
      styles.calendar
    )}
    listItems={[
      { google: 'Google Calendar', icon: <FaGoogle /> },
      { apple: 'Apple Calendar', icon: <FaApple /> },
      { outlookcom: 'Outlook.com', icon: <FaWindows /> },
      { outlook: 'Outlook (Desktop)', icon: <FaWindows /> },
      { yahoo: 'Yahoo Calendar', icon: <FaYahoo /> }
    ]}
  />
);

export default AddToCalendar;
